import { render, staticRenderFns } from "./VideoPlayerSection.vue?vue&type=template&id=39c2b086&scoped=true"
import script from "./VideoPlayerSection.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerSection.vue?vue&type=script&lang=ts"
import style0 from "./VideoPlayerSection.vue?vue&type=style&index=0&id=39c2b086&prod&lang=scss&scoped=true"
import style1 from "./VideoPlayerSection.vue?vue&type=style&index=1&id=39c2b086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c2b086",
  null
  
)

export default component.exports